import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './NotificationsManager.css';
import Sidebar from '../components/Sidebar';
import Buttons from '../components/Button';

interface EmailTemplate {
  id: number;
  name: string;
  subject: string;
  body: string;
}

interface PushNotification {
  id: number;
  title: string;
  message: string;
}

const NotificationsManager: React.FC = () => {
  const [emailTemplates, setEmailTemplates] = useState<EmailTemplate[]>([]);
  const [newTemplate, setNewTemplate] = useState({ name: '', subject: '', body: '' });
  const [editEmailId, setEditEmailId] = useState<number | null>(null);

  const [pushList, setPushList] = useState<PushNotification[]>([]);
  const [push, setPush] = useState({ title: '', message: '' });
  const [editPushId, setEditPushId] = useState<number | null>(null);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    axios.get('http://localhost:5000/emailTemplates').then(res => setEmailTemplates(res.data));
    axios.get('http://localhost:5000/pushNotifications').then(res => setPushList(res.data));
  }, []);

  // EMAIL TEMPLATE CRUD
  const handleAddOrUpdateTemplate = () => {
    if (editEmailId !== null) {
      axios.put(`http://localhost:5000/emailTemplates/${editEmailId}`, newTemplate).then(res => {
        setEmailTemplates(emailTemplates.map(t => (t.id === editEmailId ? res.data : t)));
        setEditEmailId(null);
        setNewTemplate({ name: '', subject: '', body: '' });
      });
    } else {
      axios.post('http://localhost:5000/emailTemplates', newTemplate).then(res => {
        setEmailTemplates([...emailTemplates, res.data]);
        setNewTemplate({ name: '', subject: '', body: '' });
      });
    }
  };

  const handleEditTemplate = (template: EmailTemplate) => {
    setEditEmailId(template.id);
    setNewTemplate({ name: template.name, subject: template.subject, body: template.body });
  };

  const handleDeleteTemplate = (id: number) => {
    axios.delete(`http://localhost:5000/emailTemplates/${id}`).then(() => {
      setEmailTemplates(emailTemplates.filter(t => t.id !== id));
    });
  };

  // PUSH NOTIFICATION CRUD
  const handleAddOrUpdatePush = () => {
    if (editPushId !== null) {
      axios.put(`http://localhost:5000/pushNotifications/${editPushId}`, push).then(res => {
        setPushList(pushList.map(p => (p.id === editPushId ? res.data : p)));
        setEditPushId(null);
        setPush({ title: '', message: '' });
      });
    } else {
      axios.post('http://localhost:5000/pushNotifications', push).then(res => {
        setPushList([...pushList, res.data]);
        setPush({ title: '', message: '' });
      });
    }
  };

  const handleEditPush = (p: PushNotification) => {
    setEditPushId(p.id);
    setPush({ title: p.title, message: p.message });
  };

  const handleDeletePush = (id: number) => {
    axios.delete(`http://localhost:5000/pushNotifications/${id}`).then(() => {
      setPushList(pushList.filter(p => p.id !== id));
    });
  };

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
      <div
        style={{
          flex: 1,
          marginLeft: isSidebarOpen ? "250px" : "60px",
          transition: "margin-left 0.3s ease",
          padding: "20px"
        }}
      >
        <div className='main-content1'>
          <div className="notifications-container">
            <h2>📧 Email Templates</h2>
            <div className="form-section">
              <input placeholder="Template Name" value={newTemplate.name} onChange={(e) => setNewTemplate({ ...newTemplate, name: e.target.value })} />
              <input placeholder="Subject" value={newTemplate.subject} onChange={(e) => setNewTemplate({ ...newTemplate, subject: e.target.value })} />
              <textarea placeholder="Body" value={newTemplate.body} onChange={(e) => setNewTemplate({ ...newTemplate, body: e.target.value })}></textarea>
              {editEmailId !== null ? (
                <Buttons
                  text="Update"
                  onClick={handleAddOrUpdateTemplate}
                  variant="update"
                  className="ml-2"
                />
              ) : (
                <Buttons
                  text="Add"
                  onClick={handleAddOrUpdateTemplate}
                  variant="add"
                  className="ml-2"
                />
              )}

            </div>

            <table className="notification-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Template Name</th>
                  <th>Subject</th>
                  <th>Body</th>
                  <th>Actions</th>
                  
                </tr>
              </thead>
              <tbody>
                {emailTemplates.map((t, index) => (
                  <tr key={t.id}>
                    <td>{index + 1}</td>
                    <td>{t.name}</td>
                    <td>{t.subject}</td>
                    <td>{t.body}</td>
                    <td>
                      <Buttons text='Edit' variant='edit' onClick={() => handleEditTemplate(t)} className='mt-2'/>
                      <Buttons text='delete' variant='delete' onClick={() => handleDeleteTemplate(t.id)} className='mt-2'/>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <h2>🔔 Push Notifications</h2>
            <div className="form-section">
              <input placeholder="Title" value={push.title} onChange={(e) => setPush({ ...push, title: e.target.value })} />
              <textarea placeholder="Message" value={push.message} onChange={(e) => setPush({ ...push, message: e.target.value })}></textarea>
              
              {editPushId !== null ? (
  <Buttons
    text="Update"
    onClick={handleAddOrUpdatePush}
    variant="update"
    className="ml-2"
  />
) : (
  <Buttons
    text="Add"
    onClick={handleAddOrUpdatePush}
    variant="add"
    className="ml-2"
  />
)}

            </div>

            <table className="push-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Title</th>
                  <th>Message</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {pushList.map((p, index) => (
                  <tr key={p.id}>
                    <td>{index + 1}</td>
                    <td>{p.title}</td>
                    <td>{p.message}</td>
                    <td>
                    
                      <Buttons text='Edit' variant='edit' onClick={() => handleEditPush(p)} className='mt-2'/>
                      <Buttons text='delete' variant='delete' onClick={() => handleDeletePush(p.id)} className='mt-2'/>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationsManager;
